import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { KnittingOrder, KnittingOrderSearchCommand } from '../../models/production/knitting-order';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})
export class KnittingOrderProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.productionApi + '/api/v1/knitting-order';

  search(
    command: KnittingOrderSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder = -1,
  ): Observable<ApiResponse<PaginatedApiResponse<KnittingOrder>>> {
    let queryParams = `?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (sortField) {
      queryParams += `&sortField=${encodeURIComponent(sortField)}&sortOrder=${sortOrder}`;
    }
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<KnittingOrder>>>(`${this.baseUrl}/search${queryParams}`, command);
  }

  public getById(id: string, materialize = false): Observable<ApiResponse<KnittingOrder>> {
    return this.httpClient.get<ApiResponse<KnittingOrder>>(this.baseUrl + '/' + id + '?materialize=' + materialize);
  }

  public getByIds(ids: string[], lightweight = false): Observable<ApiResponse<KnittingOrder[]>> {
    return this.httpClient.post<ApiResponse<KnittingOrder[]>>(`${this.baseUrl}/batch/ids?lightweight=${lightweight}`, ids);
  }
}
